module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921072651_T.e79e654e.jpg";